module.exports = { id: "tyres", url: "/build/app/img/symbols.svg#tyres", viewBox: "", toString: function() { return this.url; } };